import React, { FC, useEffect, useState, useMemo, Fragment } from 'react'
import { observer } from 'mobx-react'
import { menuMobx, cartMobx, restaurantConfig, storeMobx } from 'restaurant'
import { buyTogetherMobx, decorationMobx, themeMobx } from '@mobxStore'
import productStyleController from '@ctrls/productStyleController'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { Empty, WaterfallSkeleton } from '@cps'
import noMealImg from '@img/no-meal.png'
import ProductItem from '@pages/recommend/components/MenuStyleDefault/ProductItem'
import './index.scss'

interface IProps {
  lazy?: boolean;
  products?: IViewProduct[];
  selectCategoryNo?: string;
}

// 存储计算结果
let lineToResult = {}
// 存储零时分组no
let saveCategoryNo = ''
/** 菜单容器宽度 去掉左侧导航 */
const wrapWidth = window.innerWidth - 74
/** 瀑布流计算定时器 */
let waterfallTimer
/** 瀑布流计算超过5次停掉 */
let calcStep = 0

const WaterfallTemplate: FC<IProps> = ({ lazy = true, products: _products }) => {
  const isBuyTogether = !!Config.buyTogetherId
  const [products, setProducts] = useState([])
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })
  const displayMode = 'waterfallCategory'
  const [height, setHeight] = useState(420)
  const hashProduct = useMemo(() => {
    const channelEatType = storeMobx.info.storeId + restaurantConfig.mpc.channel + restaurantConfig.mpc.eatType
    return channelEatType + products.map(p => p.no).join('')
  }, [products])

  const calcWaterfall = () => {
    clearTimeout(waterfallTimer)
    if (displayMode !== restaurantConfig.displayMode) return
    const productsSolts = cloneDeep(products)
    const payload = productStyleController.waterfall(productsSolts, lazy, 'no', 'decorateProduct', 'mini')
    if (payload) {
      const { styleMap, height } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      setHeight(height)
    } else {
      if (calcStep <= 5) {
        setProductStyleMap({})
        waterfallTimer = setTimeout(() => {
          calcWaterfall()
        }, 300)
        ++calcStep
      }
    }
  }
  useEffect(() => {
    saveCategoryNo = ''
    if (products.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 300)
      }
    }
  }, [products, hashProduct])

  useEffect(() => {
    setProducts(productStyleController.setProductImgHeight(_products))
  }, [_products])

  useEffect(() => {
    if (restaurantConfig.displayMode !== 'waterfallCategory') {
      clearTimeout(waterfallTimer)
    }
    return () => {
      productStyleController.clearWaterfallData()
      clearTimeout(waterfallTimer)
    }
  }, [restaurantConfig.displayMode])

  useEffect(() => {
    lineToResult = {}
    productStyleController.clearWaterfallData()
    calcStep = 0
  }, [])
  return (
    <>
      {
        menuMobx.isLoading ? <WaterfallSkeleton /> : products.length ? ( // 且有餐品
          <div className='waterfall-style product-list-content'>
            {/* <BTAndCouponBar /> */}
            {/* <p className='title'>{selectCategoryNo ? productMobx.categoryNoToCategoryMap[selectCategoryNo].name : i18n.t('common.meals')}</p> */}
            <div className='decorateProduct-waterfall-template' style={{ height }}>
              {
                products.map((product, i) => {
                  let isFirstProd = false
                  const categoryNo = product.categoryNo || ''
                  if (categoryNo !== saveCategoryNo) {
                    isFirstProd = true
                    saveCategoryNo = categoryNo
                  }
                  const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                  return (
                    <Fragment key={product.no + categoryNo}>
                      {
                        // 用于侧边栏定位
                        isFirstProd ? (
                          <div
                            className='category-item'
                            id={`category-item-${categoryNo}`}
                            data-id={`category-${categoryNo}`}
                            style={productStyleMap[product.no + categoryNo] || { visibility: 'hidden' }}
                          >
                          </div>
                        ) : null
                      }
                      <ProductItem
                        wrapWidth={wrapWidth}
                        mealDecorates={decorationMobx.mealDecorates || {} as TMealCommonDecorates}
                        style={productStyleMap[product.no + categoryNo] || { visibility: 'hidden' }}
                        key={`${product.no}_${categoryNo}`}
                        product={product}
                        count={count}
                        sourceName='decorateProduct'
                        size='mini'
                        backgroundMode={themeMobx.data.backgroundMode}
                      />
                    </Fragment>
                  )
                })
              }
            </div>
          </div>
        ) : ( // 无餐品
          <Empty
            msg={themeMobx?.data?.abnormalStateSetting?.[0]?.subName || ''}
            iconType='dicon'
            iconName={themeMobx?.data?.abnormalStateSetting[0]?.icon}
            picUrl={themeMobx?.data?.abnormalStateSetting[0]?.pic || noMealImg}
            height='55vh'
          />
        )
      }
    </>
  )
}
export default observer(WaterfallTemplate)

// 缓存瀑布流数据
;(window as any).waterfallLineToResult = lineToResult
